import { createContext, useContext, useMemo, useState } from "react";
import { STRINGS } from "@/lib/strings";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "en");
  const value = useMemo(() => {
    const setLang = (l) => { localStorage.setItem("lang", l); setLangState(l); document.documentElement.lang = l; };
    const t = (key) => STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
    const pick = (obj, field) => (lang === "hi" && obj?.[`${field}_hi`]) || obj?.[field] || "";
    return { lang, setLang, t, pick };
  }, [lang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
